import "./Glowing-Cards.css";

const VALUE_PROPS = [
  {
    icon: "fa-solid fa-cubes-stacked",
    title: "One-Stop Solution",
    text:
      "Covering an expanse of software products and web services; Ant Fire Labs is your one-stop solution for all business possibilities online. From need analysis and solution design to ongoing support and software services — we stay by your side.",
  },
  {
    icon: "fa-solid fa-bullseye",
    title: "Right Fit, Right Away",
    text:
      "We quickly place highly skilled, experienced professionals who are the right fit for your company. Industry knowledge, specialized IT recruiters and rigorous skills testing match the right people with the right roles.",
  },
  {
    icon: "fa-solid fa-rocket",
    title: "Build Tomorrow, Today",
    text:
      "Our modern learning tracks and experienced staff are truly invested in your success. Candidates get lifetime access to a career services team that has successfully placed thousands of candidates globally.",
  },
];

const STATS = [
  { value: "50+", label: "Projects delivered" },
  { value: "30+", label: "Engineers on call" },
  { value: "10+", label: "Tech stacks supported" },
  { value: "99%", label: "Client retention" },
];

const GlowingCards = () => {
  return (
    <section id="why" className="why section">
      <div className="container">
        <div className="why__head reveal">
          <span className="eyebrow">Why Ant Fire Labs</span>
          <h2 className="section-title">
            Partners who <span className="grad">deliver</span>, not just promise.
          </h2>
          <p className="section-sub">
            Three reasons global teams choose Ant Fire Labs as their IT consulting and staffing
            partner of choice.
          </p>
        </div>

        <div className="why__grid">
          {VALUE_PROPS.map((v, i) => (
            <article
              key={v.title}
              className="why-card reveal"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="why-card__glow" aria-hidden="true" />
              <div className="why-card__icon">
                <i className={v.icon} />
              </div>
              <h3 className="why-card__title">{v.title}</h3>
              <p className="why-card__text">{v.text}</p>
              <span className="why-card__number">0{i + 1}</span>
            </article>
          ))}
        </div>

        <div className="stats reveal">
          {STATS.map((s) => (
            <div key={s.label} className="stat">
              <div className="stat__value">{s.value}</div>
              <div className="stat__label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlowingCards;
